module.exports = __webpack_public_path__ + "img/ty_3.576d9ca2.png";